<template>
  <div v-if="$v && !showPreloader">
    <DiscountPopup v-if="!isDiscountApplied && !paymentStarted" />

    <div class="app-header">
      <div class="app-header__timer" v-if="isShowTimer">
        <div class="container">
          <timer-component />
        </div>
      </div>
      <div class="app-header__name" :class="{ 'app-header__name--margin': isShowTimer }">
        <div class="container py-3">
          <div class="row align-items-center">
            <div class="col-7 col-md-2">
              <img :src="productData.logo_image" class="w-100" alt="Logo" />
              <h2 class="d-md-none">{{ productData.page_title }}</h2>
            </div>
            <div class="col-8 d-none d-md-block text-center">
              <h1>{{ productData.page_title }}</h1>
            </div>
            <div class="col-5 col-md-2">
              <img :src="productData.image[0]" class="w-100" />
            </div>
          </div>
        </div>
      </div>
      <div class="app-header__features">
        <div class="container d-flex flex-row justify-content-between py-4 px-4">
          <div v-for="(feature, id) in headerFeatures" :key="'feature' + id" class="app-header__features__item d-flex">
            <img :src="imageFeatureCheck" class="mx-2" />
            <span v-html="feature"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="progress-steps mb-2 justify-content-center">
      <div class="progress-steps__1">1. {{ textCheckout }}</div>
      <div class="progress-steps__2">2. {{ textSpecialOffers }}</div>
      <div class="progress-steps__3">3. {{ textConfirmation }}</div>
    </div>

    <div class="container main">
      <div class="row">
        <div class="col-md-7">
          <div class="paper main__deal">
            <div class="paper__title text-center">
              {{ textFreeShipping }}
            </div>
            <div class="paper__content">
              <ProductOffer />
            </div>

            <hr />

            <div class="paper__content">
              <step-title :title="textChooseDeal" :step="1" smaller step-color="#16a085" />

              <div v-if="isDiscountApplied" class="main__deal__coupon my-3">
                {{ $t('checkout.coupon_approved') }}
              </div>

              <Installments popperClass="emc1-popover-variant" :extraFields="extraFields" :form="form" />

              <span class="error" v-show="$v.form.deal.$dirty && $v.form.deal.$invalid" v-html="textMainDealError"></span>

              <!-- DEALS list -->
              <div v-for="(deal, id) in dealList" class="deal" :class="{ selected: deal.quantity === form.deal, sellout: deal.sellout }" :key="'deal' + id" @click="setDeal(deal)">
                <div v-if="deal.sellout" class="deal-sellout" @click.stop></div>

                <div class="d-flex">
                  <div v-if="deal.is_bestseller" class="deal__stripe">
                    <img :src="imageStripe" />
                  </div>

                  <div class="col-1 align-self-center text-right text-sm-center">
                    <img :src="deal.quantity === form.deal ? imageRadioOn : imageRadioOff" alt="" />
                  </div>

                  <div class="col-4 col-sm-4 align-self-center">
                    <img :src="productImagesList[deal.quantity]" class="deal__image mx-2 my-2" />
                  </div>

                  <div class="deal__description py-3 col-7 col-sm-7 d-flex flex-column align-self-center">
                    <span class="deal__title--2 mb-2 mb-sm-0">
                      {{ dealsMainQuantities[deal.quantity] }}x
                      {{ productData.product_name }}
                      <span v-if="dealsFreeQuantities[deal.quantity]">
                        + {{ dealsFreeQuantities[deal.quantity] }}
                        <b>{{ textFree }}</b>
                      </span>
                      &nbsp;

                      <span class="deal__title--1">
                        {{ productData.labels[deal.quantity] }}
                      </span>
                    </span>

                    <strike class="deal__price--old mb-2">
                      {{ textOriginalPrice }}: <span class="text-nowrap">{{ deal.price_text_old }}</span>
                    </strike>

                    <div class="deal__price text-nowrap">
                      {{ deal.unit_value_text }}
                      <small>/{{ textUnit }}</small>
                    </div>

                    <div class="deal__title--3 mt-2 mb-2 mb-sm-0">
                      <ul>
                        <li>{{ deal.discount_percent }}% {{ textDiscount }}</li>
                        <li>{{ textYouSave }}: {{ deal.save_value_text }}</li>
                        <li>{{ textTotal }}: {{ deal.price_text }}</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div v-if="deal.quantity >= 5" class="deal__button">
                  {{ textFreeWorldwideShipping }}
                </div>
              </div>

              <div v-if="isShowVariant" class="variant-selection">
                <Variant :$v="$v.form.variant" :form="form" name="variant" @change="onVariantChange">
                  <template #label>
                    <variant-title smaller step-color="#16a085" :step="2" />
                  </template>
                </Variant>
              </div>

              <div v-if="$root.isAffIDEmpty && form.deal" class="price-total">
                <div class="label">{{ textTotalAmount }}</div>
                <div class="value">{{ xprice_total_text }}</div>
              </div>
            </div>

            <hr class="mt-3" />

            <!-- REVIEWS -->
            <div class="paper__content d-none d-md-block" v-if="showReviews">
              <h4>{{ textVerifiedCustomerReview }}</h4>
              <div v-for="(review, id) of productData.reviews.slice(0, 3)" :key="'review' + id" class="review d-flex mt-3">
                <div>
                  <div class="review__avatar">
                    <img class="lazy" :data-src="review.image" alt="" />
                  </div>
                  <div class="review-5star" :style="{ width: review.rate * 20 + 'px' }">
                    <img class="lazy" :data-src="image5star" />
                  </div>
                </div>
                <div class="pl-3 w-100">
                  <div class="review__header d-flex justify-content-between">
                    <div class="review__verified">
                      <img class="lazy mr-2" :data-src="imageVerifiedCheck" />
                      {{ textReviewsVerified }}
                    </div>
                    <div class="text-align-right">
                      {{ review.name }}
                    </div>
                  </div>
                  <div class="mt-2 review__text">"{{ review.text }}"</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="paper col-md-5 main__payment">
          <form class="paper__content" @submit.prevent.stop="submit">
            <!-- PAYMENT INFO -->
            <payment-form-zmc10
              :extraFields="extraFields"
              :stateExtraField="stateExtraField"
              :startStep="isShowVariant ? 3 : 2"
              @setPaymentMethodByCardNumber="setPaymentMethodByCardNumber"
              :paymentForm="form"
              :$v="$v"
            />

            <WarrantyZMC10 :form="form" v-if="form.deal" class="mb-3" />

            <PurchasAlreadyExists v-if="isPurchasAlreadyExists" />
            <template v-else>
              <Terms v-if="$root.isAffIDEmpty" :$v="$v.form.terms" :form="form" name="terms" />
              <p v-if="paymentError" id="payment-error" class="error-container" v-html="paymentError"></p>

              <button
                :disabled="isSubmitted"
                v-if="form.paymentProvider !== 'paypal'"
                id="purchase-button"
                type="submit"
                class="green-button-animated"
                :class="{ 'green-button-active': !isSubmitted }"
              >
                <Spinner v-if="isSubmitted" />
                <div v-if="isSubmitted" class="purchase-button-disabled"></div>
                <span class="purchase-button-text" :style="{ visibility: isSubmitted ? 'hidden' : 'visible' }">{{ textSubmitButton }}</span>
              </button>

              <paypal-button
                v-if="$root.paypalEnabled"
                v-show="form.paymentProvider === 'paypal'"
                :createOrder="paypalCreateOrder"
                :onApprove="paypalOnApprove"
                :$vterms="$v.form.terms"
                :$vvariant="$v.form.variant"
                :$vdeal="$v.form.deal"
                @click="paypalSubmit"
                >{{ paypalRiskFree }}</paypal-button
              >
              <p v-if="paypalPaymentError" id="paypal-payment-error" class="error-container" v-html="paypalPaymentError"></p>

              <img :src="imageSecure" @click="scrollToForm" class="w-100 px-3 d-block mx-auto" style="max-width: 361px" />

              <div class="d-none d-md-block">
                <h4 class="mt-4 mb-4">{{ textWhyChoose }}</h4>

                <div v-if="isUsWarehouse" class="d-flex main__payment__feature mb-4">
                  <div>
                    <img :src="imageUsFlag" class="main__payment__feature__icon mr-2" />
                  </div>
                  <div class="px-2 main__payment__feature__text" v-html="$t('nmc9.us_shipping_text')"></div>
                </div>

                <div class="d-flex main__payment__feature">
                  <div>
                    <img :src="imageGuarantee" class="main__payment__feature__icon mr-2" />
                  </div>
                  <div class="px-2 main__payment__feature__text" v-html="$t('nmc9.guarantee_text')"></div>
                </div>

                <div class="d-flex main__payment__feature mt-4 mb-4">
                  <div>
                    <img :src="imageSupport" class="main__payment__feature__icon mr-2" />
                  </div>
                  <div class="px-2 main__payment__feature__text" v-html="$t('nmc9.customer_service')"></div>
                </div>
              </div>
            </template>
          </form>
        </div>
      </div>

      <!-- Only for mobile one-column layout (TODO: make as separate component) -->
      <div class="d-md-none">
        <h4 class="mt-4 mb-4">{{ textWhyChoose }}</h4>

        <div v-if="isUsWarehouse" class="d-flex main__payment__feature mb-4">
          <div>
            <img :src="imageUsFlag" class="main__payment__feature__icon mr-2" />
          </div>
          <div class="px-2 main__payment__feature__text" v-html="$t('nmc9.us_shipping_text')"></div>
        </div>

        <div class="d-flex main__payment__feature">
          <div>
            <img :src="imageGuarantee" class="main__payment__feature__icon mr-2" />
          </div>
          <div class="px-2 main__payment__feature__text" v-html="$t('nmc9.guarantee_text')"></div>
        </div>

        <div class="d-flex main__payment__feature mt-4 mb-4">
          <div>
            <img :src="imageSupport" class="main__payment__feature__icon mr-2" />
          </div>
          <div class="px-2 main__payment__feature__text" v-html="$t('nmc9.customer_service')"></div>
        </div>
      </div>

      <div class="d-md-none" v-if="showReviews">
        <h4>{{ textVerifiedCustomerReview }}</h4>

        <div class="d-flex my-4">
          <div class="col-4">
            <div class="rate-box d-flex flex-column justify-content-between">
              <div class="rate-box-value align-items-center justify-content-center d-flex">
                4.8
              </div>
              <div class="rate-box-outof align-items-center justify-content-center d-flex">{{ textRateBoxOutof }} 5.0</div>
            </div>
          </div>
          <div class="col-8 align-items-center "><RatingChart /> <br /></div>
        </div>

        <div v-for="(review, id) of productData.reviews" :key="'review' + id" class="review d-flex mt-3">
          <div>
            <div class="review__avatar">
              <img class="lazy" :data-src="review.image" alt="" />
            </div>
            <div class="review-5star" :style="{ width: review.rate * 20 + 'px' }">
              <img class="lazy" :data-src="image5star" />
            </div>
          </div>
          <div class="pl-3 w-100">
            <div class="review__header d-flex justify-content-between">
              <div class="review__verified">
                <img class="lazy mr-2" :data-src="imageVerifiedCheck" />
                {{ textReviewsVerified }}
              </div>
              <div class="text-align-right">
                {{ review.name }}
              </div>
            </div>
            <div class="mt-2 review__text">"{{ review.text }}"</div>
          </div>
        </div>

        <div :disabled="isSubmitted" type="submit" class="green-button-animated text-center mt-4" :class="{ 'green-button-active': !isSubmitted }" @click="scrollToForm">
          <span class="purchase-button-text" :style="{ visibility: isSubmitted ? 'hidden' : 'visible' }">{{ textSubmitButton }}</span>
        </div>
      </div>
      <!-- End mobile only blocks -->
    </div>

    <!-- <div class="app-footer text-center py-3  mt-5">
      <div class="container ">
        <div class="">
          <div class="d-flex justify-content-between">
            <div class="text-nowrap">{{ textAllRights }} &copy;</div>
            <div>
              <a href="/contact-us">{{ textContactUs }}</a>
              <span class="d-none d-md-inline-block">|</span>
              <a href="/terms">{{ textTerms }}</a>
              <span class="d-none d-md-inline-block">|</span>
              <a href="/privacy">{{ textPrivacy }}</a>
              <span class="d-none d-md-inline-block">|</span>
              <a href="/delivery">{{ textDelivery }}</a>
              <span class="d-none d-md-inline-block">|</span>
              <a href="/report-abuse">{{ textReportSpam }}</a>
              <span class="d-none d-md-inline-block">|</span>
              <a href="https://forms.gle/mL4DRiqmxtMyQ3Fb8" target="_blank" rel="nofollow">{{ $t("footer.affiliate") }}</a>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <el-dialog @click="isOpenPromotionModal = false" class="cvv-popup" :title="promo_modal_title" :lock-scroll="false" :visible.sync="isOpenPromotionModal">
      <div class="cvv-popup__content">
        <p class="error-container" v-html="promo_modal_text"></p>

        <button @click="isOpenPromotionModal = false" style="height: 67px; margin: 0" type="button" class="green-button-animated">
          <span class="purchase-button-text" v-html="textMainDealErrorPopupButton"></span>
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import smc7validation from "../validation/smc7-validation";
import scrollToError from "../mixins/formScrollToError";
import globals from "../mixins/globals";
import notification from "../mixins/notification";
import * as extraFields from "../mixins/extraFields";
import queryToComponent from "../mixins/queryToComponent";
import blackFriday from "../mixins/blackFriday";
import christmas from "../mixins/christmas";
import { t, timage } from "../utils/i18n";
import { getNotice, getRadioHtml } from "../utils/emc1";
import Terms from "./common/common-fields/Terms";
import Spinner from "./common/preloaders/Spinner";
import ProductItem from "./common/ProductItem";
import Variant from "./common/common-fields/Variant";
import WarrantyZMC10 from "./common/WarrantyZMC10";
import ProductOffer from "../components/common/ProductOffer";
import RatingChart from "../components/common/RatingChart";
import PurchasAlreadyExists from "./common/PurchasAlreadyExists";
import Installments from "./common/extra-fields/Installments";
import { fade } from "../utils/common";
import { preparePurchaseData } from "../utils/checkout";
import purchasMixin from "../mixins/purchas";
import { paypalCreateOrder, paypalOnApprove } from "../utils/emc1";
import { ipqsCheck } from "../services/ipqs";
import { logUnitQuantity } from "../services/fingerprintjs2";
import { checkForLeadsRequest, sendCheckoutRequest, get3dsErrors, isUsWarehouse } from "../utils/checkout";
import { queryParams } from "../utils/queryParams";
import logger from "../mixins/logger";
import DiscountPopup from "./common/DiscountPopup";
import VariantTitle from "./common/checkout-step/VariantTitle";
import StepTitle from "./common/checkout-step/StepTitle";

export default {
  name: "zmc10",
  mixins: [globals, notification, scrollToError, queryToComponent, extraFields.tplMixin, purchasMixin, blackFriday, christmas, logger],
  components: {
    StepTitle,
    VariantTitle,
    ProductItem,
    Variant,
    WarrantyZMC10,
    ProductOffer,
    RatingChart,
    PurchasAlreadyExists,
    Installments,
    Terms,
    Spinner,
    DiscountPopup
  },
  props: ["showPreloader", "skusList"],
  data() {
    return {
      isFormShown: false,
      paypalPaymentError: "",
      selectedProductData: {
        prices: null,
        quantity: null
      },
      form: {
        isWarrantyChecked: false,
        countryCodePhoneField: js_data.country_code,
        deal: null,
        variant: js_data.product.skus.length === 1 || !js_data.product.is_choice_required ? (js_data.product.skus[0] && js_data.product.skus[0].code) || null : null,
        paymentProvider: null,
        fname: null,
        lname: null,
        email: null,
        phone: null,
        street: null,
        city: null,
        zipcode: null,
        country: js_data.countries.indexOf(js_data.country_code) !== -1 ? js_data.country_code : null,
        cardHolder: null,
        cardNumber: null,
        cardDate: null,
        cvv: null,
        terms: null
      },
      isOpenPromotionModal: false,
      productImage: this.getProductImage(),
      disableAnimation: true,
      isOpenSpecialOfferModal: false,
      isSubmitted: false,
      paymentError: "",
      paymentStarted: false,
    };
  },
  created() {
    const openForm = +js_query_params.openform;

    this.form.paymentProvider = "credit-card"; // TODO if not setting default value - form not displaying

    if (js_data.customer) {
      this.form.paymentProvider = "credit-card";
      this.isFormShown = true;
    }

    if (openForm !== 0 && (!this.$root.paypalEnabled || openForm === 1)) {
      this.form.paymentProvider = "credit-card";
      this.isFormShown = true;
    }

    if (this.queryParams["3ds"] && this.queryParams["3ds"] !== "success") {
      try {
        const selectedProductData = JSON.parse(localStorage.getItem("selectedProductData")) || {};
        this.form.deal = selectedProductData.deal || this.form.deal;
        this.form.variant = selectedProductData.variant || this.form.variant;
        this.form.isWarrantyChecked = selectedProductData.isWarrantyChecked || this.form.isWarrantyChecked;
        this.form.paymentProvider = selectedProductData.paymentProvider || this.form.paymentProvider;
        this.form.fname = selectedProductData.fname || this.form.fname;
        this.form.lname = selectedProductData.lname || this.form.lname;
        this.form.email = selectedProductData.email || this.form.email;
        this.form.phone = selectedProductData.phone || this.form.phone;
        this.form.countryCodePhoneField = selectedProductData.countryCodePhoneField || this.form.countryCodePhoneField;
        this.form.street = selectedProductData.street || this.form.street;
        this.form.city = selectedProductData.city || this.form.city;
        this.form.zipcode = selectedProductData.zipcode || this.form.zipcode;
        this.form.country = selectedProductData.country || this.form.country;
        this.isFormShown = true;
      } catch (err) {}
    }

    setTimeout(() => {
      this.disableAnimation = false;
    }, 1000);

    this.restore_customer(
      (fname, lname, email, street, city, zipcode, country) => {
        this.form.fname = fname;
        this.form.lname = lname;
        this.form.email = email;
        this.form.street = street;
        this.form.city = city;
        this.form.zipcode = zipcode;
        this.form.country = country;
      },
      (countryCodePhoneField, phone) => {
        this.form.countryCodePhoneField = countryCodePhoneField;
        this.form.phone = phone;
      }
    );
  },
  computed: {
    companyAddress() {
      return js_data.company_address.replace(" - ", "<br>");
    },
    companyDescriptorPrefix() {
      return this.$root.isAffIDEmpty ? js_data.company_descriptor_prefix : "";
    },
    isShowVariant() {
      return this.variantList.length > 1 && (!js_query_params.variant || js_query_params.variant === "0");
    },
    productData() {
      return js_data.product;
    },
    // process HTML description to pull features highlights
    headerFeatures() {
      var features = [];
      var el = document.createElement("html");
      el.innerHTML = this.productData.home_description;
      for (let li of el.getElementsByTagName("li")) {
        features.push(li.innerHTML);
      }
      return features;
    },
    showReviews() {
      return js_query_params.reviews_off !== "1";
    },
    dealsAllowedQuantities() {
      return [5, 1, 3];
    },
    dealsMainQuantities() {
      return {
        1: 1,
        2: 2,
        3: 2,
        4: 4,
        5: 3
      };
    },

    dealsFreeQuantities() {
      return {
        1: 0,
        2: 0,
        3: 1,
        4: 0,
        5: 2
      };
    },

    dealsSellout() {
      return (js_query_params.sellout || "").split(",").map(quantity => +quantity);
    },
    dealList() {
      return this.dealsAllowedQuantities.map(value => {
        return {
          ...this.productData.prices[value],
          price_text:
            this.form.installments > 1
              ? this.form.installments + " x " + this.productData.prices[value][`installments${this.form.installments}_value_text`]
              : this.productData.prices[value].value_text,
          price_text_old:
            this.form.installments > 1
              ? this.form.installments + " x " + this.productData.prices[value][`installments${this.form.installments}_old_value_text`]
              : this.productData.prices[value].old_value_text,
          sellout: this.dealsSellout.indexOf(+value) !== -1,
          quantity: +value
        };
      });
    },

    productImagesList() {
      const variant = this.form.variant || (js_data.product.skus[0] && js_data.product.skus[0].code) || null;

      const skus = Array.isArray(js_data.product.skus) ? js_data.product.skus : [];

      const product = skus.find(sku => variant === sku.code);

      return product.quantity_image;
    },
    purchase() {
      const variant = this.form.variant || (js_data.product.skus[0] && js_data.product.skus[0].code) || null;

      return preparePurchaseData({
        purchaseList: this.productData.prices,
        product_name: this.productData.product_name,
        installments: this.form.installments,
        variant
      });
    },
    variantList() {
      return this.skusList.map(it => ({
        label: it.name,
        text: `<div><img src="${it.quantity_image[1]}" alt=""><span>${it.name}</span></div>`,
        value: it.code,
        imageUrl: it.quantity_image[1]
      }));
    },
    price_total_text() {
      let result = "";

      if (this.form.deal) {
        switch (this.form.installments) {
          case 1:
            result = this.form.isWarrantyChecked ? js_data.product.prices[this.form.deal].total_amount_text : js_data.product.prices[this.form.deal].value_text;
            break;
          case 3:
            result = this.form.isWarrantyChecked
              ? js_data.product.prices[this.form.deal].installments3_total_amount_text
              : js_data.product.prices[this.form.deal].installments3_value_text;
            break;
          case 6:
            result = this.form.isWarrantyChecked
              ? js_data.product.prices[this.form.deal].installments6_total_amount_text
              : js_data.product.prices[this.form.deal].installments6_value_text;
            break;
        }
      }

      return result;
    },
    price_multiplier() {
      return this.form.installments !== 1 ? this.form.installments + "× " : "";
    },
    xprice_total_text() {
      return this.price_multiplier + this.price_total_text;
    },
    isShowTimer() {
      return this.queryParams["show_timer"] == 1 || this.queryParams["show_timer"] === "{timer}";
    },
    isDiscountApplied() {
      return !!js_query_params.coupon;
    },
    isUsWarehouse: () => isUsWarehouse(),
    textMainDealText: () => t("checkout.main_deal.message", { country: t("country." + js_data.country_code) || "" }),
    textStep: () => t("checkout.step"),
    textChooseDeal: () => t("checkout.choose_deal"),
    textArtcile: () => t("checkout.article"),
    textPrice: () => t("checkout.header_banner.price"),
    textMainDealError: () => t("checkout.main_deal.error"),
    textMainDealErrorPopupButton: () => t("checkout.main_deal.error_popup.button"),
    textSelectVariant: () => t("checkout.select_variant"),
    textPaySecurely: () => t("checkout.pay_securely"),
    textPaySecurelyAPM: () => t("checkout.pay_securely_apm"),
    textSafeSSLEncryption: () => t("checkout.safe_sll_encryption"),
    textCreditCardInvoiced: () => t("checkout.credit_card_invoiced"),
    textContactInformation: () => t("checkout.contact_information"),
    textDeliveryAddress: () => t("checkout.delivery_address"),
    textPaymentDetails: () => t("checkout.payment_details"),
    textSpecialOfferPopupTitle: () => t("checkout.special_offer_popup.title"),
    textSpecialOfferPopupMessage: () => t("checkout.special_offer_popup.message"),
    textSpecialOfferPopupButtonPurchase: () => t("checkout.special_offer_popup.button_purchase"),
    textSpecialOfferPopupButtonEmpty: () => t("checkout.special_offer_popup.button_empty"),
    paypalRiskFree: () => t("checkout.paypal.risk_free"),
    textTotalAmount: () => t("checkout.total_amount"),
    imageSafePayment: () => timage("safe_payment"),
    textReviewsTitle: () => t("fmc5.reviews.title"),
    textReviewsVerified: () => t("fmc5.reviews.verified"),
    textFree: () => t("fmc5.free"),
    textOff: () => t("fmc5.off"),
    textAllRights: () => t("footer.all_rights"),
    textPrivacy: () => t("footer.privacy"),
    textDelivery: () => t("footer.delivery"),
    textReportSpam: () => t("abuse.title"),
    textContactUs: () => t("footer.contact"),
    textTerms: () => t("footer.terms"),
    textNoticeAtCollection: () => t("footer.notice_at_collection"),
    textBestValue: () => t("checkout.best_value_deal"),
    textFreeWorldwideShipping: () => t("checkout.free_worldwide_shipping"),
    textRateBoxOutof: () => t("fmc5.rate_box.outof"),
    textVerifiedCustomerReview: () => t("nmc9.reviews.title"),
    textOriginalPrice: () => t("checkout.original_price"),
    textTotal: () => t("checkout.summary.total"),
    textUnit: () => t("checkout.unit"),
    textDiscount: () => t("checkout.discount"),
    textYouSave: () => t("checkout.you_save"),
    textCheckout: () => t("checkout.page_title"),
    textSpecialOffers: () => t("checkout.special_offers"),
    textConfirmation: () => t("checkout.confirmation"),
    textFreeShipping() {
      return this.isUsWarehouse ? this.$t("checkout.free_shipping_today_order_us") : this.$t("checkout.free_shipping_today_order");
    },
    textSubmitButton() {
      return this.$t(this.isUsWarehouse ? "checkout.payment_form_us.submit_button_product" : "checkout.payment_form.submit_button_product", {
        PRODUCT: this.productData.product_name
      });
    },
    textWhyChoose() {
      return this.$t("checkout.why_choose", { PRODUCTNAME: this.productData.product_name });
    },
    image5star() {
      return this.$root.cdn_url + "/assets/images/zmc10/5star.svg";
    },
    imageVerifiedCheck() {
      return this.$root.cdn_url + "/assets/images/zmc10/check.svg";
    },
    imageFeatureCheck() {
      return this.$root.cdn_url + "/assets/images/zmc10/check-white.svg";
    },
    imageStripe() {
      return this.$root.cdn_url + "/assets/images/zmc10/best-seller-ribbon.png";
    },
    imageSupport() {
      return this.$root.cdn_url + "/assets/images/zmc10/support-icon-gray.svg";
    },
    imageGuarantee() {
      return this.$root.cdn_url + "/assets/images/zmc10/guarantee-icon-gray.svg";
    },
    imageSecure() {
      return this.$root.cdn_url + "/assets/images/zmc10/secure-icons.png";
    },
    imageWarranty() {
      return this.$root.cdn_url + "/assets/images/zmc10/warranty.png";
    },
    imageUsFlag() {
      return this.$root.cdn_url + "/assets/images/zmc10/us-flag.svg";
    },
    imageRadioOn() {
      return this.$root.cdn_url + "/assets/images/zmc10/radio-on.svg";
    },
    imageRadioOff() {
      return this.$root.cdn_url + "/assets/images/zmc10/radio-off.svg";
    },

    promo_modal_title() {
      if (this.$v.form.deal.$invalid) {
        return t("checkout.main_deal.error_popup.title");
      } else if (this.$v.form.variant.$invalid) {
        return t("checkout.select_variant");
      }
    },
    promo_modal_text() {
      if (this.$v.form.deal.$invalid) {
        return t("checkout.main_deal.error_popup.message");
      } else if (this.$v.form.variant.$invalid) {
        return t("checkout.select_variant");
      }
    },
    dialCode() {
      const allCountries = window.intlTelInputGlobals.getCountryData();
      const phoneCountryCode = this.form.countryCodePhoneField;
      const country = allCountries.filter(item => item.iso2 === phoneCountryCode).shift();

      return country ? country.dialCode : "1";
    }
  },
  watch: {
    "form.deal"(value, oldValue) {
      window.selectedOffer = value ? 1 : 0;
      history.pushState({}, "", location.href);
      this.print_pixels("cart");

      // log every qtty change by user, skipping initial
      if (oldValue) {
        logUnitQuantity(value);
      }
    },
    "form.paymentProvider"(value) {
      window.selectedPayment = value;
      history.pushState({}, "", location.href);
      this.print_pixels("payment");
    },
    purchase() {
      this.refreshTopBlock();
    },
    "form.payment_method"() {
      const selected_method = this.$root.paymentMethods[this.form.payment_method];

      if (this.form.payment_method === "instant_transfer") {
        this.form.paymentProvider = "paypal";
      } else if (selected_method && selected_method.is_apm) {
        this.form.paymentProvider = this.form.payment_method;
      } else {
        this.form.paymentProvider = "credit-card";
      }
    }
  },
  validations: smc7validation,
  methods: {
    setDeal(deal) {
      this.form.deal = deal.quantity;
    },
    onVariantChange() {
      // this.animateProductImage();
    },
    activateForm() {
      this.isFormShown = true;

      setTimeout(() => {
        this.scrollToSelector(".payment-form");
      }, 100);
    },
    paypalSubmit() {
      this.paymentStarted = true;

      logUnitQuantity(this.form.deal);

      if (this.$v.form.deal.$invalid) {
        this.$v.form.deal.$touch();

        const element = document.querySelector(".main__deal");

        if (element && element.scrollIntoView) {
          element.scrollIntoView();
        }

        this.isOpenPromotionModal = true;
      } else if (this.$v.form.variant.$invalid) {
        this.$v.form.variant.$touch();

        const element = document.querySelector(".variant-selection");

        if (element && element.scrollIntoView) {
          element.scrollIntoView();
        }

        this.isOpenPromotionModal = true;
      } else if (this.$v.form.terms && this.$v.form.terms.$invalid) {
        const element = document.querySelector(".terms-checkbox");

        if (element && element.scrollIntoView) {
          element.scrollIntoView();
        }

        this.$v.form.terms.$touch();
      }
    },
    paypalCreateOrder() {
      let ipqsResult = null;

      this.form.paymentProvider = "paypal";

      const currency = !js_query_params.cur || js_query_params.cur === "{aff_currency}" ? js_data.product.prices.currency : js_query_params.cur;

      this.setDataToLocalStorage({
        deal: this.form.deal,
        variant: this.form.variant,
        isWarrantyChecked: this.form.isWarrantyChecked,
        paymentProvider: "paypal"
      });

      this.paypalPaymentError = "";

      return Promise.resolve()
        .then(() => {
          const data = {
            order_amount: this.getOrderAmount(this.form.deal, this.form.isWarrantyChecked)
          };

          return ipqsCheck(data);
        })
        .then(result => {
          ipqsResult = result;
        })
        .then(() => {
          if (ipqsResult && ipqsResult.recent_abuse) {
            if (this.form.country === "br") {
              this.log_data("BRAZIL: ZMC10 - PayPal - IPQS - recent_abuse", {
                fraud_chance: ipqsResult.fraud_chance,
                ipqs: ipqsResult
              });
            }

            return Promise.reject({
              custom_error: t("checkout.abuse_error")
            });
          }

          if (this.ipqs_paypal_restricted(ipqsResult)) {
            return Promise.reject({
              custom_error: t("checkout.payment_error.area_restriction")
            });
          }

          return paypalCreateOrder({
            xsrfToken: document.head.querySelector('meta[name="csrf-token"]').content,
            sku_code: this.form.variant,
            sku_quantity: this.form.deal,
            is_warranty_checked: this.form.isWarrantyChecked,
            page_checkout: document.location.href,
            cur: currency,
            offer: js_query_params.offer || null,
            affiliate: js_query_params.affiliate || null,
            ipqsResult
          });
        })
        .then(res => {
          if (res.error && this.form.country === "br") {
            this.log_data("BRAZIL: ZMC10 - PayPal - response", {
              error: res.paypalPaymentError,
              res: { ...res, paypalPaymentError: undefined },
              fraud_chance: ipqsResult.fraud_chance,
              ipqs: ipqsResult
            });
          }

          if (res.paypalPaymentError) {
            this.paypalPaymentError = res.paypalPaymentError;
          }

          return res;
        })
        .catch(err => {
          this.paypalPaymentError = !err || !err.custom_error ? t("checkout.payment_error") : err.custom_error;
        });
    },
    paypalOnApprove(data) {
      return paypalOnApprove(data);
    },
    setPromotionalModal(val) {
      this.isOpenPromotionModal = val;
    },
    refreshTopBlock() {
      const oldPrice = document.querySelector("#old-price");
      const newPrice = document.querySelector("#new-price");
      let oldValueText, valueText;

      switch (this.form.installments) {
        case 3:
          oldValueText = js_data.product.prices[1].installments3_old_value_text;
          valueText = js_data.product.prices[1].installments3_value_text;
          break;
        case 6:
          oldValueText = js_data.product.prices[1].installments6_old_value_text;
          valueText = js_data.product.prices[1].installments6_value_text;
          break;
        case 1:
        default:
          oldValueText = js_data.product.prices[1].old_value_text;
          valueText = js_data.product.prices[1].value_text;
          break;
      }

      if (oldPrice) {
        document.querySelector("#old-price").innerHTML = this.quantityOfInstallments + oldValueText;
      }

      if (newPrice) {
        document.querySelector("#new-price").innerHTML = this.quantityOfInstallments + valueText;
      }
    },
    getProductImage() {
      const isInitial = !this.productImage;
      const quantity = /*this.form && +this.form.deal || */ 1;

      const skus = Array.isArray(js_data.product.skus) ? js_data.product.skus : [];

      const variant = (this.form && this.form.variant) || (skus[0] && skus[0].code) || null;
      const skuVariant = (skus.find && skus.find(sku => variant === sku.code)) || null;

      const productImage = js_data.product.image[+(js_query_params.image || null) - 1] || js_data.product.image[0];
      const skuImage = (skuVariant && (skuVariant.quantity_image[quantity] || skuVariant.quantity_image[1])) || productImage;

      return isInitial ? productImage : skuImage;
    },
    animateProductImage() {
      const newProductImage = this.getProductImage();

      if (newProductImage !== this.productImage) {
        if (!this.disableAnimation) {
          const imgPreload = new Image();
          imgPreload.src = newProductImage;

          fade("out", 300, document.querySelector("#product-image"), true).then(() => {
            this.productImage = newProductImage;
            setTimeout(() => fade("in", 300, document.querySelector("#product-image"), true), 200);
          });
        } else {
          this.productImage = newProductImage;
        }
      }
    },
    scrollToForm() {
      setTimeout(() => this.scrollToSelector(".payment-form-zmc10"), 100);
    },
    submit() {
      let ipqsResult = null;

      this.$v.form.$touch();
      if (this.$v.form.$invalid && this.form.country === "br") {
        this.log_data("BRAZIL: ZMC10 - Credit Card - form validation", {
          invalid: Object.keys(this.$v.form)
            .filter(name => name !== "cardNumber" && !!this.$v.form[name].$invalid)
            .reduce((acc, name) => {
              acc[name] = this.$v.form.$model[name];
              return acc;
            }, {}),
          form: { ...this.$v.form.$model, cardNumber: undefined }
        });
      }

      if (this.$v.form.deal.$invalid) {
        const element = document.querySelector(".smc7__deal");

        if (element && element.scrollIntoView) {
          element.scrollIntoView();
        }

        this.setPromotionalModal(true);
        return;
      } else if (this.$v.form.variant.$invalid) {
        const element = document.querySelector(".variant-selection");

        if (element && element.scrollIntoView) {
          element.scrollIntoView();
        }

        this.setPromotionalModal(true);
        return;
      }

      if (this.$v.form.$pending || this.$v.form.$error) {
        this.scrollToError();
        return;
      }

      if (this.isSubmitted) {
        return;
      }

      this.paymentError = "";
      this.isSubmitted = true;

      const phoneNumber = (this.form.phone || "").replace(/[^0-9]/g, "");
      const cardNumber = (this.form.cardNumber || "").replace(/[^0-9]/g, "");

      if (this.form.emailForceInvalid) {
        if (this.form.country === "br") {
          this.log_data("BRAZIL: ZMC10 - Credit Card - email blocked", {
            email: this.form.email,
            form: { ...this.$v.form.$model, cardNumber: undefined }
          });
        }

        return setTimeout(() => {
          this.paymentError = t("checkout.abuse_error");
          this.isSubmitted = false;
        }, 1000);
      }

      let data = {
        deal: this.form.deal,
        variant: this.form.variant,
        isWarrantyChecked: this.form.isWarrantyChecked,
        paymentProvider: this.form.paymentProvider,
        fname: this.form.fname,
        lname: this.form.lname,
        email: this.form.email,
        phone: this.form.phone,
        countryCodePhoneField: this.form.countryCodePhoneField,
        streetAndNumber: this.form.streetAndNumber,
        city: this.form.city,
        zipcode: this.form.zipCode,
        country: this.form.country
      };

      this.setExtraFieldsForLocalStorage(data);
      this.setDataToLocalStorage(data);

      Promise.resolve()
        .then(() => {
          let data = {
            order_amount: this.getOrderAmount(this.form.deal, this.form.isWarrantyChecked),
            billing_first_name: this.form.fname,
            billing_last_name: this.form.lname,
            billing_country: this.form.country,
            billing_address_1: this.form.streetAndNumber,
            billing_city: this.form.city,
            billing_region: this.extraFields.state ? this.form.state : "",
            billing_postcode: this.form.zipCode,
            billing_email: this.form.email,
            billing_phone: this.dialCode + phoneNumber
          };

          if (this.form.paymentProvider === "credit-card") {
            data.credit_card_bin = cardNumber.substr(0, 6);
            data.credit_card_expiration_month = this.form.cardDate.split("/")[0];
            data.credit_card_expiration_year = this.form.cardDate.split("/")[1];
            data.cvv_code = this.form.cvv;

            if (window.sha256) {
              data.credit_card_hash = sha256(cardNumber);
            }
          }

          return ipqsCheck(data);
        })
        .then(result => {
          ipqsResult = result;
        })
        .then(() => {
          let data = {
            product: {
              sku: this.form.variant,
              qty: parseInt(this.form.deal, 10),
              is_warranty_checked: this.form.isWarrantyChecked
            },
            contact: {
              phone: {
                country_code: this.dialCode,
                number: phoneNumber
              },
              first_name: this.form.fname,
              last_name: this.form.lname,
              email: this.form.email
            },
            address: {
              city: this.form.city,
              country: this.form.country,
              zip: this.form.zipCode,
              street: this.form.streetAndNumber
            },
            ipqs: ipqsResult
          };

          if (this.form.state) {
            data.address.state = this.form.state;
          }

          if (this.form.paymentProvider === "credit-card") {
            data.card = {
              number: cardNumber,
              cvv: this.form.cvv,
              month: this.form.cardDate.split("/")[0],
              year: "20" + this.form.cardDate.split("/")[1]
            };

            if (this.$root.isAffIDEmpty) {
              data.card.holder = this.form.cardHolder;
            }
          }

          this.setExtraFieldsForCardPayment(data, this.form.paymentProvider);

          return sendCheckoutRequest(data, this.form.paymentProvider);
        })
        .then(res => {
          if (res.status !== "ok" && this.form.country === "br") {
            this.log_data("BRAZIL: ZMC10 - Credit Card - response", {
              error: res.paymentError,
              res: { ...res, paymentError: undefined },
              form: { ...this.$v.form.$model, cardNumber: undefined },
              fraud_chance: ipqsResult.fraud_chance,
              ipqs: ipqsResult
            });
          }

          if (res.paymentError) {
            this.paymentError = res.paymentError;
            this.isSubmitted = false;
          }
        })
        .catch(err => {
          console.log("ERR", err);
          this.paymentError = t("checkout.payment_error");
          this.isSubmitted = false;
        });
    }
  },
  mounted() {
    const qty = +this.queryParams.qty || js_data.product.default_qty;
    const deal = this.purchase.find(({ totalQuantity }) => qty === totalQuantity);

    if (deal) {
      this.form.deal = qty;
    }

    this.refreshTopBlock();
    this.lazyload_update();
  },
  updated() {
    this.lazyload_update();
  }
};
</script>

<style lang="scss">
@import "../../sass/variables";
$white: #fff;
$color_flush_mahogany_approx: #e74c3c;
$red: #e74c3c;
$color_niagara_approx: #16a085;

.tpl-zmc10 {
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 14px;
  line-height: 20px;
  background-color: #f1f4f8;

  .terms-checkbox a {
    text-decoration: underline;
  }

  // remove body padding
  main.pt-4 {
    padding: 0 !important;
  }

  #app {
    width: 100%;
    padding: 0;
  }

  // hide elements from blade templates, as we need to customize it
  #header,
  .fixed-region #timer-component {
    display: none;
  }

  h4 {
    font-size: 16px;
    font-weight: normal;
  }

  // dropdown input margin fix
  div.select {
    margin-bottom: 10px;
  }

  .progress-steps {
    font-size: 16px;
    line-height: 19px;
    color: white;
    white-space: nowrap;
    display: flex;

    [dir="rtl"] & {
      display: none;
    }

    &__1 {
      background: #0089cc;
      border-radius: 3px;
      font-weight: bold;
      padding: 8px 30px 8px 35px;

      &:after {
        position: absolute;
        content: "";
        width: 30px;
        height: 30px;
        background-color: #0089cc;
        border-top: 5px solid #f1f4f8;
        border-right: 5px solid #f1f4f8;
        transform: rotate(45deg);
        margin-top: -5px;
        margin-left: 16px;
      }
    }

    &__2 {
      background: #026190;
      padding: 8px 35px 8px 50px;

      &:after {
        position: absolute;
        content: "";
        width: 30px;
        height: 30px;
        background-color: #026190;
        border-top: 5px solid #f1f4f8;
        border-right: 5px solid #f1f4f8;
        transform: rotate(45deg);
        margin-top: -5px;
        margin-left: 24px;
      }
    }

    &__3 {
      background: #001326;
      border-radius: 0px 3px 3px 0px;
      padding: 8px 30px 8px 45px;
    }
  }

  .app-header {
    margin-bottom: 40px;

    &__timer {
      background-color: #ffc439;
      font-size: 24px;
      line-height: 35px;
      font-family: Roboto, Arial, Helvetica, sans-serif;
      position: fixed;
      z-index: 15;
      width: 100%;
      height: 48px;
      overflow: hidden;

      // we need to overwrite some cool timer styling to make it look simplier
      .timer-component > .desktop {
        justify-content: center;

        > span {
          width: auto;
          margin-right: 10px;
        }
      }
      .timer-component__minutes > div,
      .timer-component__seconds > div {
        background-color: transparent;
        padding: 0;
        color: black;
        font-size: 24px;
        text-shadow: none;
      }
      .timer-component__dots {
        padding: 9px 0;
        span {
          box-shadow: none;
        }
      }
      .line {
        display: none;
      }
      .timer-component .mobile {
        background-color: transparent;
        color: black;
        font-size: 20px;
      }
    }

    &__name {
      background-color: #fff;

      // add space due to fixed timer
      &--margin {
        padding-top: 48px;
      }

      h1 {
        font-size: 30px;
        line-height: 37px;
        font-weight: normal;
      }

      h2 {
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 24px;
      }
    }

    &__features {
      background-color: #0d68d8;
      color: white;

      strong {
        font-weight: normal;
      }
    }
  }

  main {
    background-color: transparent;
  }

  h2 {
    font-weight: bold;
    font-size: 18px;
    line-height: 20px;
    color: #16a085;

    span {
      color: #333333;
    }
  }

  hr {
    border-color: #f3f3f3;
    margin: 0;
  }

  .paper {
    padding: 0;
    border-radius: 10px;
    box-shadow: none;

    &__title {
      color: white;
      background-color: #1cc509;
      padding: 7px;
      font-weight: 600;
      border-radius: 9px 9px 0 0;
    }

    &__content {
      padding: 12px 20px;
    }
  }

  .offer {
    p {
      font-family: Roboto, Arial, Helvetica, sans-serif;
      color: #333333;
      line-height: 25px;
      font-size: 16px;
    }

    .offer__special {
      color: #e74c3c;
    }
    .productprice-object {
      color: #16a085;
    }
  }

  .deal {
    display: block;
    border: 3px solid #ebebeb;
    border-radius: 10px;
    margin-top: 8px;
    padding: 0;
    position: relative;
    cursor: pointer;

    &:hover {
      background-color: #cfe5fc;
      border: 1px solid #057ffd;
      padding: 1px; // compensate border size change by adding padding
    }

    &.selected {
      border: 1px solid #057ffd;
      box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.4);
      background-color: #b6daff;
      padding: 1px; // compensate border size change by adding padding
    }

    .deal__stripe {
      position: absolute;
      z-index: 10;
      right: -12px;
      top: -9px;

      img {
        width: 82px;
        height: 82px;
      }

      // for text on stripe
      span {
        position: absolute;
        transform: rotate(28deg);
        color: #fff;
        font-size: 10px;
        margin-top: 25px;
        margin-left: 22px;
      }
    }

    .deal__image {
      max-width: 141px;
      width: 100%;
    }

    .deal__price {
      font-size: 25px;
      line-height: 35px;
      color: #282828;

      small {
        font-size: 16px;
        line-height: 22px;
      }
    }

    .deal__price--old {
      color: #8c8c8c;
      font-size: 16px;
      line-height: 22px;
    }

    .deal__price--total {
      font-size: 18px;
      line-height: 35px;
      color: #16a085;
    }

    .deal__description {
      // font-family: "Noto Sans", Arial;
    }

    .deal__title--1 {
      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
      text-transform: uppercase;
      color: #e74c3c;
    }

    .deal__title--2 {
      font-size: 18px;
      line-height: 24px;
      color: #333333;
    }

    .deal__title--3 {
      font-size: 15px;
      line-height: 18px;
      color: #16a085;

      ul {
        padding-left: 20px;
      }
    }

    .deal__button {
      background-color: #be3398;
      box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.4);
      border-radius: 0 0 9px 9px;
      text-align: center;
      text-transform: uppercase;
      color: #ffffff;
      font-size: 16px;
      line-height: 22px;
      padding: 10px 0;
    }
  }

  .review {
    flex-direction: row;
    padding: 0;
    border-top: 0;
    font-family: Roboto, Arial, Helvetica, sans-serif;

    &__header {
      font-size: 14px;
    }

    &__avatar {
      height: 64px;
      overflow: hidden;

      & > img {
        width: 93px;
        border-radius: 50%;
        margin-top: -15px;
        padding: 3px;
        border: 1px solid rgb(181, 181, 181);
      }
    }

    &__verified {
      color: #16a085;
    }

    &__text {
      font-size: 16px;
    }
  }

  .rate-box {
    background-color: #3574d7;
    color: #fff;
    width: 100%;
  }

  .rate-box-value {
    font-size: 40px;
    font-weight: 600;
    height: 75px;
  }

  .rate-box-outof {
    background-color: #003854;
    font-size: 18px;
    font-weight: 600;
    height: 32px;
  }

  .container {
    max-width: 1000px;

    > .row {
      justify-content: space-between;
      margin: 0;

      > .col-md-7 {
        flex: 0 0 55%;
        max-width: 55%;
        padding: 0;
      }

      > .col-md-5 {
        flex: 0 0 42%;
        max-width: 42%;
      }
    }
  }

  // restyle main green button
  .green-button-animated {
    background-color: #1ac70e;
    box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.4);
    border-radius: 6px;
    background-image: none;
    border: 0;
    font-weight: bold;
    font-size: 18px;
    line-height: 26px;
    text-shadow: none;
    padding: 21px 21px;
  }

  .app-footer {
    background-color: #fff;
    border-top: 1px solid #eee;
    font-size: 14px;
    color: #333;
    // font-family: Roboto, sans-serif;

    a {
      color: #064870;
      // font-size: 10px;
      margin: 0 5px;
    }
  }

  @media (min-width: 768px) {
    .container {
      max-width: 750px;
    }
  }

  @media (min-width: 992px) {
    .container {
      max-width: 970px;
    }
  }

  @media (min-width: 1200px) {
    .container {
      max-width: 1100px;
    }
  }

  // mobile version
  @media (max-width: 768px) {
    h4 {
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      line-height: 22px;
    }

    .progress-steps {
      display: none; // temp solution for mobile phones

      font-size: 13px;
      &__1 {
        padding: 6px 20px 6px 15px;
        &:after {
          margin-top: -3px;
          margin-left: 6px;
          width: 26px;
          height: 26px;
        }
      }
      &__2 {
        padding: 6px 20px 6px 30px;
        &:after {
          margin-left: 6px;
          margin-top: -3px;
          width: 26px;
          height: 26px;
        }
      }
      &__3 {
        padding: 6px 15px 6px 25px;
      }
    }

    .app-header {
      margin-bottom: 20px;

      &__features {
        font-size: 12px;
        line-height: 20px;

        &__item img {
          width: 15px;
        }

        // less items for mobile to fit
        &__item:last-child {
          display: none !important;
        }
      }
    }

    .deal .deal__button {
      font-size: 14px;
      line-height: 22px;
    }

    .container {
      padding-left: 7px;
      padding-right: 7px;
    }

    .container > .row {
      > .col-md-7,
      .col-md-5 {
        flex: 0 0 100%;
        max-width: 100%;
      }

      .col-md-5 {
        margin-top: 20px;
      }
    }

    .paper__content {
      padding: 9px 10px;
    }
  }

  #warranty-field-button {
    margin-top: 22px;

    label[for="warranty-field"] {
      @media screen and (max-width: 991px) {
        & {
          font-size: 14px;
          margin: 18px 40px 18px 80px;

          [dir="rtl"] & {
            margin: 18px 80px 18px 40px;
          }
        }
      }
    }
  }

  .price-total {
    display: flex;
    font-size: 17px;
    margin: 10px 20px 5px;

    .value {
      margin-left: auto;
    }
  }
}

.accessories-modal {
  & > p {
    text-align: center;
    font-size: 17px;
  }

  &__bottom {
    display: flex;
    flex-direction: column;

    button {
      margin: 50px auto 10px;
      width: 70%;
      max-width: 395px;
      padding: 5px;
    }

    .thanks {
      font-size: 17px;
      margin: 0 auto;
      border: 0;
      background-color: transparent;
      cursor: pointer;
      text-decoration: underline;
    }
  }
}

.main {
  padding-top: 20px;

  & > .row {
    align-items: flex-start;
  }

  .col-7 {
    padding-right: 20px;
  }

  &__sale {
    //float: left;
    margin-right: 20px;
    margin-bottom: 10px;

    [dir="rtl"] & {
      margin-left: 20px;
      //margin-right: 0;
    }
  }

  &__deal__text {
    font-size: 16px;
    line-height: 25px;
    font-style: normal;
    color: #333333;

    strong {
      font-size: 16px;
    }

    [dir="rtl"] & {
      padding-left: 0;
      //padding-right: 20px;
    }
  }

  .radio-button-group {
    .label-container-radio__label {
      font-size: 16px;
    }

    .label-container-radio__name-price {
      display: flex;
      justify-content: space-between;
    }

    .label-container-radio__best-seller {
      display: flex;
      justify-content: space-between;
      color: $red;
      .label-container-radio__price {
        margin-left: auto;
      }
    }

    .label-container-radio__best-seller__name {
      text-transform: uppercase;
    }

    .label-container-radio__best-seller__price {
      color: $red;
    }

    .label-container-radio__discount {
      display: flex;
      justify-content: space-between;

      .discount-text {
        color: $color_niagara_approx;

        &.red {
          color: $red;
        }
      }
    }

    .label-container-radio.with-discount .label-container-radio__name-price > span:nth-child(2) {
      text-decoration: line-through;
    }

    .label-container-radio__best-seller__soldout,
    .label-container-radio__name-price__soldout {
      display: none;
    }
  }

  .label-container-radio.disabled {
    .label-container-radio__name-price {
      flex-wrap: wrap;
    }
    .label-container-radio__name-price__name {
      order: 2;
      flex: 0 0 100%;
    }
    .label-container-radio__name-price__soldout {
      display: inline-block;
    }
    .label-container-radio__best-seller__soldout {
      display: inline-block;
      margin-right: auto;
      &:before {
        display: inline-block;
        padding: 0 3px;
        content: "-";
      }
    }
  }
  .label-container-radio.disabled.labeled {
    .label-container-radio__name-price {
      flex-wrap: nowrap;
    }
    .label-container-radio__name-price__name {
      order: 0;
      flex: 1 1 auto;
    }
  }

  &__deal {
    h3 {
      padding-left: 20px;
    }

    &__coupon {
      text-transform: uppercase;
      text-align: center;
      font-weight: 600;
      color: #688868;
    }

    .share {
      position: absolute;
      transform: rotate3d(-10, -3, 0, 180deg);
      height: auto;
      width: 40px;
      top: -17px;
      left: -30px;

      [dir="rtl"] & {
        left: auto;
        right: -30px;
        transform: rotate(145deg);
      }

      @media screen and ($s-down) {
        width: 24px;
        top: 0;
        left: -9px;

        [dir="rtl"] & {
          left: auto;
          right: -9px;
        }
      }
    }

    .radio-button-group {
      .label-container-radio {
        &:nth-child(2) {
          background: #fef036;
        }

        &:hover {
          background: #fef9ae;
        }
      }
    }
  }

  &__payment {
    display: flex;
    flex-direction: column;

    &__feature {
      // font-family: Roboto;
      font-size: 16px;
      line-height: 19px;

      &__icon {
        width: 46px;
        max-width: none !important;
      }

      &__text > div:first-child {
        margin-bottom: 3px;
      }
    }

    h2,
    h3 {
      margin: 10px 0;
    }

    h3 {
      margin-top: 0;
    }

    img {
      align-self: center;
      flex-shrink: 0;
      max-width: 100%;
      height: auto;
    }
  }

  &__credit-card-switcher {
    width: 100%;
    padding: 0 !important;
    height: auto !important;
    margin-bottom: 0;

    .label-container-radio {
      background-color: transparent !important;
      border: 0 !important;
      color: $white;
      cursor: pointer;
      margin: 0 0 10px;

      &.bank-payment {
        border-radius: 3px;
        background-image: linear-gradient(to bottom, #fff 0, #f6f6f6 53%, #ececec 100%);
        border: 1px solid #efefef;
        color: #333;

        &:before {
          opacity: 0;
          font-family: FontAwesome !important;
          content: "\f054";
          width: 0;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 0 50% 50% 0;
          background-color: rgba(255, 255, 255, 0.3);
          transition: all 0.2s linear 0s;
        }

        &:hover {
          background-color: #e6e6e6;
          background-image: linear-gradient(to bottom, #e6e6e6 0, #ddd 53%, #d3d3d3 100%);

          &:before {
            opacity: 1;
            width: 30px;
          }
        }

        .checkmark {
          border-color: #333;

          &:after {
            background-color: #333;
          }
        }
      }

      &:first-child {
        height: auto;
        border: 1px solid #0f9b0f;
        background: #ff2f21 linear-gradient(#0f9b0f, #0d840d) repeat scroll 0% 0% / auto padding-box border-box;

        &:hover {
          background-image: linear-gradient(to bottom, #6d4 0, #3d6c04 100%);
        }
      }

      &:hover {
        background-color: #e6e6e6;
      }

      &__label {
        font-size: 15px;
      }

      .checkmark {
        border-color: $white;
        background-color: transparent;

        &:after {
          background-color: $white;
        }
      }
    }
  }

  &__bottom {
    width: 100%;
    display: flex;
    flex-direction: column;

    img {
      width: 80%;
      margin: 0 auto;
    }

    p {
      padding: 4px 24px;
      text-align: center;
      font-size: 13px;

      i {
        position: relative;
        margin-right: 4px;
        top: 2px;
        font-size: 18px;
        color: #409eff;

        [dir="rtl"] & {
          margin-left: 4px;
          margin-right: 0;
        }
      }
    }
  }

  @media screen and (max-width: 767px) {
    .col-md-7 {
      padding: 0;
    }
  }

  .variant-selection {
    margin-top: 10px;
  }
}

*[dir="rtl"] {
  .radio-button-group .label-container-radio {
    padding: 15px 45px 15px 15px;

    .checkmark {
      left: unset;
      right: 15px;
    }
  }

  .main__payment {
    .first-name {
      margin-right: 0;
    }

    .last-name {
      margin-right: 0;
    }

    .card-date {
      padding-right: 0;
      padding-left: 30px;

      & > div {
        margin-right: 0;

        &:last-child {
          margin-right: 10px;
        }
      }
    }
  }

  .iti__flag-container {
    left: auto;
  }
}

.special-offer-popup {
  .el-dialog {
    margin-top: 10vh !important;
  }
}

@media screen and ($s-down) {
  .special-offer-popup {
    .el-dialog {
      width: 100%;
      margin-top: 0 !important;

      .accessories-modal {
        &__list {
          .product-item {
            &__image {
              padding: 0;
            }

            &__main {
              padding-left: 20px;
            }
          }
        }
      }
    }
  }

  .accessories-modal__bottom {
    button {
      width: 100%;
    }
  }
}
</style>
